export var SendEventType;
(function (SendEventType) {
    SendEventType["BATCH"] = "batch";
})(SendEventType || (SendEventType = {}));
export var ReportEventType;
(function (ReportEventType) {
    ReportEventType["PAGEVIEW"] = "pageview";
    ReportEventType["JS_ERROR"] = "js_error";
    ReportEventType["REQUEST"] = "ajax";
    ReportEventType["SET_DATA"] = "set_data";
    ReportEventType["ON_READY"] = "on_ready";
    ReportEventType["FIRST_LOAD"] = "first_load";
})(ReportEventType || (ReportEventType = {}));
export var BackendEventType;
(function (BackendEventType) {
    BackendEventType["DEVICE_ID"] = "device_id";
    BackendEventType["FINDER_CONFIG"] = "finder_config";
    BackendEventType["TESTER_SDK_VERSION"] = "tester_sdk_version";
    BackendEventType["ENV_INFO"] = "env_info";
    BackendEventType["NETWORK_STATUS"] = "network_status";
    BackendEventType["JS_ERROR"] = "js_error";
    BackendEventType["GLOBAL_JS_ERROR"] = "global_js_error";
    BackendEventType["APP_SESSION"] = "app_session";
    BackendEventType["PAGE_SESSION"] = "page_session";
    BackendEventType["REQUEST"] = "request";
    BackendEventType["SET_DATA"] = "set_data";
    BackendEventType["PAGE_ON_READY"] = "page_on_ready";
    BackendEventType["PAGE_FIRST_LOAD"] = "page_first_load";
})(BackendEventType || (BackendEventType = {}));
//# sourceMappingURL=report.js.map